import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

const SETTLE_MS = 800;

export type SaveState = "idle" | "saving" | "saved";

export function useSaveStatus(): SaveState {
  const form = useFormContext();
  const [state, setState] = useState<SaveState>("idle");
  const [edits, setEdits] = useState(0);

  useEffect(() => {
    if (!form) return undefined;

    const subscription = form.watch((_values, { type }) => {
      if (type !== "change") return;
      setEdits((count) => count + 1);
    });

    return () => subscription.unsubscribe();
  }, [form]);

  useEffect(() => {
    if (!edits) return undefined;

    setState("saving");
    const timer = setTimeout(() => setState("saved"), SETTLE_MS);

    return () => clearTimeout(timer);
  }, [edits]);

  return state;
}
